import { Outlet, useNavigation } from 'react-router-dom';
import styled from 'styled-components';
import { ToastContainer } from 'react-toastify';
import { LoadingOverlay } from '@/components/LoadingOverlay';

/**
 * Port of the old `_boundary.tsx` layout: page-transition fade, global toast
 * container, and a loading overlay during navigation. The Remix `ErrorBoundary`
 * export becomes the route-level `errorElement` (see RouteError).
 */
export function BoundaryLayout() {
    const navigation = useNavigation();
    const isTransitioning = navigation.state === 'loading';

    return (
        <PageTransition $isTransitioning={isTransitioning}>
            <Outlet />

            {isTransitioning && <LoadingOverlay />}

            <StyledToastContainer autoClose={8000} />
        </PageTransition>
    );
}

const PageTransition = styled.div<{ $isTransitioning: boolean }>`
    opacity: ${({ $isTransitioning }) => ($isTransitioning ? 0.8 : 1)};
    transition: opacity 0.2s ease-in-out;
`;

const StyledToastContainer = styled(ToastContainer)`
    &&&.Toastify__toast-container {
        --toastify-color-success: ${({ theme }) => theme.colors.darkGreen};
        --toastify-color-progress-success: ${({ theme }) => theme.colors.green};
        --toastify-toast-padding: 16px;
    }
    .Toastify__toast {
        font-family: ${({ theme }) => theme.fonts.secondary.regular};
        font-size: 16px;
        line-height: 1.5;
        font-weight: 600;
    }
    .Toastify__close-button svg {
        fill: ${({ theme }) => theme.colors.white};
    }
    .Toastify__toast--error {
        background-color: ${({ theme }) => theme.colors.darkRed};
        --toastify-text-color-dark: white;
        --toastify-text-color-light: white;
        --toastify-icon-color-error: white;
    }
    .Toastify__toast--success {
        background-color: ${({ theme }) => theme.colors.darkGreen};
        --toastify-text-color-dark: white;
        --toastify-text-color-light: white;
        --toastify-icon-color-success: white;
    }
`;
